// @flow
import * as React from 'react';
import Icons from '../../../styles/Icons';

interface Props {
  selectProps: {
    menuIsOpen: boolean
  };
}

function SignupDropdownIndicator(props: Props) {
  if (props.selectProps.menuIsOpen) {
    return <i className="material-icons arrow">{Icons.KEYBOARD_ARROW_DOWN}</i>;
  }

  return <i className="material-icons arrow">{Icons.KEYBOARD_ARROW_UP}</i>;
}

export default SignupDropdownIndicator;
